import { HTTPFetchNetworkInterface } from 'apollo-client'

export class GraphQLNetworkInterface extends HTTPFetchNetworkInterface {
  setUri (uri) {
    // debugger
    this._uri = 'uri'
  }
}



// WEBPACK FOOTER //
// ./src/setup/GraphQLNetworkInterface.js